module.exports = __webpack_public_path__ + "91b7acfa4a5ebcf4be28ac8c9069c631.svg";